import { db } from "firebase-config";
import { onSnapshot, collection } from "firebase/firestore";
import { store } from "app/store";
import { communityCollectionName } from "./collectionNames";
import { Community } from "model/Community/Community";
import { updateCommunities } from "app/slices/CommunitySlice";

type CommunityDoc = {
  communities: Community[];
};

let snapshotSetup = false;

export const setupCommunitySnapshot = () => {
  if (snapshotSetup === true) {
    return;
  }

  snapshotSetup = true;
  onSnapshot(collection(db, communityCollectionName), (querySnapshot) => {
    const communities = querySnapshot.docs.flatMap(
      (d) => (d.data() as CommunityDoc).communities
    );

    store.dispatch(
      updateCommunities({
        communities,
      })
    );
  });
};

export const isCommunitySnapshotSetup = () => snapshotSetup;
